import Cookies from "js-cookie";

export const storeLead = async (data) => {
  try {
    const userUUID = Cookies.get("muvi_useruuid");

    const dataToSend = {
      ...data,
      created_by: userUUID,
      contact_added_from: "intranet",
      muvi_useruuid: userUUID,
    };

    const response = await fetch(
      process.env.REACT_APP_CRM + "/crm/contacts/create",
      {
        method: "POST",
        body: JSON.stringify(dataToSend),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    const res = await response.json();

    if (!res || res.code != 200) {
      return {
        success: false,
        message: "Failed to create lead",
        code: res.code || 500,
      };
    }

    return {
      success: true,
      message: "Lead created successfully",
      code: res.code || 200,
    };
  } catch (error) {
    console.error("Error saving lead:", error);

    return {
      success: false,
      message: "An unexpected error occurred",
      code: 500,
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/actions/StoreLeadAction.js